import useChat from '../../hooks/chat/useChat'
import { IoArrowUp, IoStopCircle } from 'react-icons/io5'
import { twMerge } from 'tailwind-merge'
import { Tooltip } from 'react-tooltip';
import MessagesDisplayer from './MessagesDisplayer';
import SearchModeDisplayer from './SearchModeDisplayer';
import ConfirmModal from '../../utils/ConfirmModal';
import BurgerMenu from './BurgerMenu';
import ContentMenu from './ContentMenu';
import { FaTrashAlt } from 'react-icons/fa';
// import backgroundImage from '../../../images/background.svg'; // Adjust the path as necessary
import backgroundImage from './background.svg';
import { isChatMode } from "./fonctions";
import SignIn from "../administration/SignIn";

export default function Chat() {
    const [
        { message, messages, chatContainerRef, bottomRef, isLargerThanInitial, withHistory, hasLLMChatPureOption, isWaitingForResponse, mode, selectedMessage, searchResponse, confirmModal, introductionText, isButtonDisabled, statusMessage, MessageSearch, selectedModifiedMessage, isLargerThanInitialOnModify, id, loggedInEndUsers },
        { handleKeyDown, handleMessageChange, autoAdaptTextArea, handleSend, createFeedback, handleRetry, setMode, setSelectedMessage, deleteConversation, displayRag, setConfirmModal, toggleHistory, dispatch, setselectedModifiedMessage, handleModify,handleStop }
    ] = useChat();

    return (
        <>
            <div className='flex w-screen h-screen'>
                <BurgerMenu>
                    <ContentMenu
                        withHistory={withHistory}
                        toggleHistory={toggleHistory}
                        hasLLMChatPureOption={hasLLMChatPureOption}
                        mode={mode}
                        setMode={setMode}
                    />
                </BurgerMenu>
                <div className={`relative flex flex-shrink flex-col max-h-screen gap-4 w-full h-full mx-auto pb-4 lg:px-0`}
                    style={{ backgroundImage: `url(${backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                    <div className='absolute left-0 top-0 w-full h-12 bg-perso-gray z-10 flex justify-end items-center shadow shadow-perso-purple md:hidden'>
                        <img src='/images/logo-black.svg' alt='logo' className='h-8 ' />
                    </div>
                    <div className='flex-grow overflow-y-auto gap-4 pb-4 pt-12 z-0 w-full' ref={chatContainerRef}>
                        {(isChatMode(mode)) ? (
                            <MessagesDisplayer
                                messages={messages}
                                statusMessage={statusMessage}
                                createFeedback={createFeedback}
                                dispatch={dispatch}
                                handleRetry={handleRetry}
                                handleModify={handleModify}
                                selectedMessage={selectedMessage}
                                setSelectedMessage={setSelectedMessage}
                                bottomRef={bottomRef}
                                chatContainerRef={chatContainerRef}
                                displayRag={displayRag}
                                firstMessage={introductionText}
                                isWaitingForResponse={isWaitingForResponse}
                                selectedModifiedMessage={selectedModifiedMessage}
                                setselectedModifiedMessage={setselectedModifiedMessage}
                                handleKeyDown={handleKeyDown}
                                autoAdaptTextArea={autoAdaptTextArea}
                                isLargerThanInitialOnModify={isLargerThanInitialOnModify}
                                messageToSend={message}
                                companyUUID={id}
                            />
                        ) : (
                            <SearchModeDisplayer
                                searchResponse={searchResponse}
                                isWaitingForResponse={isWaitingForResponse}
                                statusMessage={statusMessage}
                                MessageSearch={MessageSearch}
                                companyUUID={id}
                            />
                        )}

                    </div>
                    <div className='place-content-end  flex gap-2 items-center justify-center w-full max-w-screen-lg mx-auto px-4'>
                        <div
                            className={` relative  w-full border border-gray-400 shadow rounded-2xl transform duration-300 flex items-center overflow-hidden `}>
                            <textarea
                                onKeyDown={handleKeyDown}
                                ref={message}
                                onInput={autoAdaptTextArea}
                                onChange={handleMessageChange}
                                className={`py-4 pr-12 text-xs sm:text-base px-3 flex-grow w-full outline-none max-h-48 bg-transparent resize-none overflow-y-auto bg-white text-black`}
                                id="isButtonDisabled"
                                tabIndex={0}
                                placeholder="Entrez votre message..."
                                rows={1}
                            />
                            <div
                                className={twMerge(`${isLargerThanInitial ? ' items-end' : ' items-center'} absolute h-full top-0 right-0 flex p-2 `)}>
                                {(!isWaitingForResponse) ?
                                    < button disabled={isButtonDisabled}
                                    className={twMerge(`cursor-pointer h-8 w-8 rounded-lg disabled:opacity-50 disabled:pointer-events-none bg-gray-500 disabled:hover:bg-none hover:bg-gray-600 transform duration-500 flex items-center justify-center`)}
                                    onClick={handleSend}>
                                    <IoArrowUp className="  h-5 w-5 text-white" />
                                    </button>: isWaitingForResponse&&< button
                                        className={twMerge(`cursor-pointer h-8 w-8 rounded-lg disabled:opacity-50 disabled:pointer-events-none bg-gray-500 disabled:hover:bg-none hover:bg-gray-600 transform duration-500 flex items-center justify-center`)}
                                        onClick={handleStop}>
                                        <IoStopCircle className="  h-5 w-5 text-white" />
                                    </button>
                                }
                            </div>
                        </div>
                        {isChatMode(mode) && messages.length > 1 && (
                            <button onClick={() => deleteConversation()}
                                disabled={isWaitingForResponse}
                                className='group hover:text-red-400 rounded-2xl p-4 border bg-white text-gray-600 border-gray-400 cursor-pointer disabled:text-gray-500 disabled:cursor-not-allowed'>
                                <FaTrashAlt className='w-5 h-5' />
                            </button>
                        )}
                    </div>
                    <Tooltip
                        id="chat-tooltip"
                        style={{ fontSize: "0.75rem", zIndex: 9999 }}
                        place='left'
                    />
                </div>
            </div >
            { confirmModal && (
                <ConfirmModal text={confirmModal.text} yes={confirmModal.yes} no={() => setConfirmModal(null)} />
            )}
            {loggedInEndUsers && <SignIn/>}
        </>
    )
}